import React from 'react';
import { useTranslation } from 'react-i18next';
import { set_interval } from '../../custom_functions/interval';
import { TimeIcon, LocationIcon, DollarSign } from '../icons';
import { Colors } from '../../constants';

const DisplayedMeetingsView = ({displayedMeetings = [], userPath, handleMeetingOnClick, languageCode = 'en', color = `#${Colors.primaryColor}`}) => {
  const { t } = useTranslation();

  const onMouseOver = (e) => {
    let element = e.target.closest('button.content-link');
    element.style.borderColor = color;
    var text_elements = element.getElementsByClassName('content-text');
    for (var i = 0; i < text_elements.length; i++ ) {
      text_elements[i].style.color = color;
    }
    var svg_elements = element.getElementsByClassName('svg-icon-custom');
    for (var j = 0; j < svg_elements.length; j++ ) {
      if ( svg_elements[j].classList.contains('fill') ) {
        svg_elements[j].style.fill = color;
      } else {
        svg_elements[j].style.stroke = color;
      }
    }
  };

  const onMouseOut = (e) => {
    let element = e.target.closest('button.content-link');
    element.style.borderColor = `#${Colors.borderGray}`;
    var text_elements = element.getElementsByClassName('content-text');
    for (var i = 0; i < text_elements.length; i++ ) {
      text_elements[i].style.color = `#${Colors.blackText}`;
    }
    var svg_elements = element.getElementsByClassName('svg-icon-custom');
    for (var j = 0; j < svg_elements.length; j++ ) {
      if ( svg_elements[j].classList.contains('fill') ) {
        svg_elements[j].style.fill = `#${Colors.blackText}`;
      } else {
        svg_elements[j].style.stroke = `#${Colors.blackText}`;
      }
    }
  };

  if(displayedMeetings.length === 0){
    return (
      <>
        No meetings
      </>
    );
  }


  let meetings = [];
  let displayed_meetings = [];
  if(displayedMeetings && displayedMeetings.length > 0){
    displayedMeetings.forEach((value, index) => {
      let time_interval = value.time_interval;
      // if(time_interval > 60){
      //   time_interval = `${time_interval/60} ${t('hours')}`;
      // }
      // else if(time_interval === 60){
      //   time_interval = `${time_interval/60}  ${t('hour')}`;
      // }
      // else if((time_interval < 60) && time_interval > 1){
      //   time_interval = time_interval + ' mins';
      // }
      // else{
      //   time_interval = time_interval + ' min';
      // }
      if(time_interval !== 'Ask Invitee') {
        time_interval = set_interval(time_interval);
        if(time_interval){
          let interval_split = time_interval.split('-');
          let detail_interval = '';

          if(interval_split.length > 1){
            detail_interval = t(interval_split[1]);
          }

          time_interval = interval_split[0].concat(' ', detail_interval)
        }
        else{
          time_interval = '-';
        }
      }

      let event_id = value.event_id.toLowerCase();
      let backgroundImage = `url('${value.background_image}')`;
      let priceFormat = (x) => {
        let amount = 0;
        amount = (Number(x)/100).toFixed(2);

        let priceSplit = amount.split(".");
        if(priceSplit.length > 1){
            priceSplit[0] = priceSplit[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
        amount = priceSplit.join(".");
        return amount;
      };

      displayed_meetings.push(
        <button
          onClick={() => handleMeetingOnClick(`${userPath}/${event_id}/?back=1`, event_id)}
          className={`content-link ${(index+1)%2 === 0 ? 'm-left' : ''}`}
          key={index}
          id={`link-${event_id}`}
          title={value.name}
          onMouseOver={(e) => onMouseOver(e)}
          onMouseOut={(e) => onMouseOut(e)} >
          {
            value.background_image &&
              <div><div className="content-background-image" style={{ backgroundImage }}>
              </div></div>
          }
          <div className={`content-item`}>
            <div className="item-wrap">
              <p className={`content-text bold-text displayed-name-text ${event_id}`} style={{ visibility: 'visible' }}>{value.name}</p>
            </div>
            <div className="item-wrap">
              <TimeIcon customClass={event_id} color={Colors.blackText} />

              <p className={`content-text text-margin-left normal-text ${event_id}`} style={{ visibility: 'visible' }}>{time_interval}</p>
            </div>

            <div className="item-wrap m-bottom">
              <LocationIcon customClass={event_id} color={Colors.blackText} />

              <p className={`content-text text-margin-left normal-text ${event_id}`} style={{ visibility: 'visible' }}>
                {value.location == null ? '-' : value.location.charAt(0).toUpperCase() + value.location.slice(1)}
              </p>
            </div>

          {
            ['stripe', 'paypal'].includes(value.payment_settings.accept_payment) &&
              <div className="item-wrap">
                <DollarSign customClass={event_id} color={Colors.blackText} />
                <p className={`content-text text-margin-left normal-text ${event_id}`} style={{ visibility: 'visible' }}>
                  { value.payment_settings.currency_code } { priceFormat(value.payment_settings.price) }
                </p>
              </div>
          }

          </div>
        </button>
      );

      // if((displayedMeetings.length-1) === index && (index+1)%2 !== 0){
      //   meetings.push(
      //     <div key={index+1} className="content-link clear-fix">
      //       <div className="content-item"></div>
      //     </div>
      //   )
      // }

      if((index+1)%2 === 0 || (displayedMeetings.length-1) === index) {
        meetings.push(
          <div className="row" key={`row-${index+1}`}>
            {displayed_meetings}
          </div>
        );
        displayed_meetings = [];
      }
    });
  }

  return meetings;
};

export default DisplayedMeetingsView;
